import React from "react";

export const Pointer = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="true"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 19 19"
    >
      <path
        d="M14.932 9.686h.003l.002 3.127a3.748 3.748 0 01-3.745 3.768H8.178c-2.267 0-3.567-2.556-3.567-2.556L2.507 9.77a1.16 1.16 0 01.524-1.548c.474-.24.907-.117 1.284.178.028.022.055.045.083.07.87.756 1.417 2.398 1.417 2.398V3.538a1.13 1.13 0 012.26 0l.003 3.655c0-.624.541-1.168 1.165-1.168a1.163 1.163 0 01.66.203 1.116 1.116 0 01.509.927v1.13a1.13 1.13 0 012.26 0V9.53a1.13 1.13 0 012.25-.16m.003.03a1.06 1.06 0 00-.004-.03l.004.03zm0 0c.005.043.007.086.007.13v.157"
        clipRule="evenodd"
      />
    </svg>
  );
};
